module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.show) ? _c('dof-overlay', _vm._b({
    attrs: {
      "show": _vm.show && _vm.hasOverlay,
      "opacity": _vm.opacity,
      "data-evt-dofOverlayBodyClicked": ""
    },
    on: {
      "dofOverlayBodyClicked": _vm.dofOverlayBodyClicked
    }
  }, 'dof-overlay', _vm.mergeOverlayCfg, false)) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('div', {
    ref: "dof-mask",
    staticClass: "dof-mask weex-ct weex-div",
    style: (_vm._px2rem(_vm.maskStyle, 75)),
    attrs: {
      "hack": _vm.shouldShow,
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm.contentStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("default", null, {})], 2), _vm._v(" "), (_vm.showClose) ? _c('div', {
    staticClass: "mask-bottom weex-ct weex-div",
    style: ({
      width: _vm._px2rem(_vm.width + 'px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('figure', {
    staticClass: "closeIcon weex-el weex-image",
    attrs: {
      "placeholder": _vm.localCloseIcon,
      "src": _vm.closeIcon,
      "data-img-src": _vm.closeIcon,
      "weex-type": "image",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.cancel($event)
      }
    }
  })]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2bc0ee67", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bc0ee67","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-mask/index.vue
// module id = 594
// module chunks = 0 1